import React from "react";
import Flexbox from "flexbox-react";
import { inject, observer } from "mobx-react";
import { Menu, MenuDivider, MenuItem, Intent, Alert, Classes } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import Avatar from "react-avatar";
import Utilities from "../../utils/Utilities";

const PROPROFS_USERS_TO_SWITCH_ACCOUNT = [
  "83657cbc-bbbf-4842-bfb3-54dd2e897a85",
  "1a954316-17e3-4968-8608-50a634edd286",
  "5cabf056-bcb3-4fbb-94ee-852ddcc63450",
  "4c711ec7-dbfe-4873-85b8-7b66c4130e8a",
];

@inject("CurrentUserStore")
@observer
export default class AccountSwitchingMenu extends React.Component {
  render() {
    const { authorizedAccounts, activeAccount, switchAccount, currentUser } = this.props.CurrentUserStore;

    // Render the Menu only if there is more than one authorized account
    if (authorizedAccounts.length <= 1) {
      return <></>;
    }

    return (
      <Menu>
        <React.Fragment>
          {authorizedAccounts
            .filter(account => {
              // 1. Exclude active account
              if (account.activeAccount) {
                return false;
              }
              // Check if this is "Delightfully Smart Tools" account
              const isSmartToolsAccount = account.accountId === "06dc188c-1ef7-4eea-ace3-b7366ec03947";

              // If Smart Tools account, only show if current user is in allowed list
              if (isSmartToolsAccount && !PROPROFS_USERS_TO_SWITCH_ACCOUNT.includes(currentUser?.id)) {
                return false; // Hide Smart Tools
              }
              
              return true;
            })
            .map(account => (
              <MenuItem
                key={account.id}
                icon={<Avatar src={account.accountImage} size={20} round />}
                text={account.accountName}
                onClick={() => {
                  switchAccount(account.accountId);
                }}
              />
            ))}
          {/* <MenuDivider /> */}
        </React.Fragment>
        {/* <MenuItem
          text={I18n.t('js.add_account')}
          icon={IconNames.PLUS}
          onClick={() => {
            Utilities.navigate('/setup');
          }}
        />
        <MenuItem
          text={I18n.t('js.leave_active_account', { accountName: activeAccount.accountName })}
          icon={IconNames.FOLLOWING}
          intent={Intent.DANGER}
          onClick={() => this.props.toggleAlert()}
        /> */}
      </Menu>
    );
  }
}
